import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainPage from '../components/MainPage';
import getReports from '../actions/api/report/getReports';
import getGroups from '../actions/api/group/getGroups';
import { SUCCESS_API_GET_USER_GROUPS } from '../actions/actionTypes';
import { PAGE_PATH } from '../lib/constants';

const ReportContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const isLogin = useSelector(state => state.main.isLogin);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const currentPage = useSelector(state => state.report.currentPage);
  const refreshPage = useSelector(state => state.report.refreshPage);
  const editDetail = useSelector(state => state.report.editDetail);
  const create = useSelector(state => state.report.create);

  useEffect(() => {
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'OPEN_REPORT' });
    dispatch(getGroups(apiToken, {}, SUCCESS_API_GET_USER_GROUPS));

    const apiParams = {
      page: currentPage,
    };

    dispatch(getReports(apiToken, apiParams, targetGroupId));

    if (refreshPage) {
      dispatch({ type: 'SET_REFRESH_PAGE_FALSE' });
    }
  }, [apiToken, currentPage, dispatch, targetGroupId, refreshPage]);

  useEffect(() => {
    if (create && editDetail.reportId) {
      history.push(`${PAGE_PATH.DS_REPORT_EDIT}/${editDetail.reportId}`);
    }
  }, [history, editDetail, create]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <MainPage />;
};

export default ReportContainer;
